export default "__VITE_ASSET__DbjoyORY__"